/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentDraftsControllerListQueryResponse, DocumentDraftsControllerListQueryParams, DocumentDraftsControllerList401, DocumentDraftsControllerList403 } from "../../models/documentDraftsController/DocumentDraftsControllerList";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { documentDraftsControllerList } from "../../clients/document-draftsService/documentDraftsControllerList";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const documentDraftsControllerListQueryKey = (params: DocumentDraftsControllerListQueryParams) => [{
  url: '/api/v1/document-drafts'
}, ...(params ? [params] : [])] as const;
export type DocumentDraftsControllerListQueryKey = ReturnType<typeof documentDraftsControllerListQueryKey>;
export function documentDraftsControllerListQueryOptions(params: DocumentDraftsControllerListQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = documentDraftsControllerListQueryKey(params);
  return queryOptions<DocumentDraftsControllerListQueryResponse, ResponseErrorConfig<DocumentDraftsControllerList401 | DocumentDraftsControllerList403>, DocumentDraftsControllerListQueryResponse, typeof queryKey>({
    enabled: !!params,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return documentDraftsControllerList(params, config);
    }
  });
}

/**
 * {@link /api/v1/document-drafts}
 */
export function useDocumentDraftsControllerList<TData = DocumentDraftsControllerListQueryResponse, TQueryData = DocumentDraftsControllerListQueryResponse, TQueryKey extends QueryKey = DocumentDraftsControllerListQueryKey>(params: DocumentDraftsControllerListQueryParams, options: {
  query?: Partial<QueryObserverOptions<DocumentDraftsControllerListQueryResponse, ResponseErrorConfig<DocumentDraftsControllerList401 | DocumentDraftsControllerList403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? documentDraftsControllerListQueryKey(params);
  const query = useQuery({
    ...documentDraftsControllerListQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<DocumentDraftsControllerList401 | DocumentDraftsControllerList403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}